import { render } from "./Recepcion.vue?vue&type=template&id=ae8e3204&scoped=true"
import script from "./Recepcion.vue?vue&type=script&lang=js"
export * from "./Recepcion.vue?vue&type=script&lang=js"

import "./Recepcion.vue?vue&type=style&index=0&id=ae8e3204&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8e3204"]])

export default __exports__